import lodashMerge from 'lodash/merge';

import {assertDependencies, padRight} from '../lib/util';

const MANIFEST = require('./manifest');

const DEFAULT_OPTIONS = {
	update_interval: 500,
	enabled: false,
	show_dots: true,
	shortcut_key: 68, // d
};

const DEFAULT_DOT_SIZE = 10;
const DEFAULT_DOT_COLOR = 'rgba(255,0,0,0.7)';

function KrPanoDebugger(options = DEFAULT_OPTIONS, deps = MANIFEST.dependencies) {
	const thisKrPanoDebugger = this;

	options = lodashMerge({}, DEFAULT_OPTIONS, options);
	assertDependencies(MANIFEST.name, MANIFEST.dependencies, deps);

	const log = deps.logger.child(MANIFEST.name);
	const $ = deps.jQuery;

	let _textElements = null;
	const _dotElements = {};
	let _interval = null; // eslint-disable-line no-unused-vars

	let _enabled = options.enabled;
	let _showDots = options.show_dots;
	let _lastOutput = null;

	Object.assign(thisKrPanoDebugger, /** @lends KrPanoDebugger.prototype */ {
		init,
		isEnabled: () => _enabled,
		enable: () => setEnabled(true),
		disable: () => setEnabled(false),
		isShowingDots: () => _showDots,
		setShowDots,
	});

	function init() {
		_interval = setInterval(update, options.update_interval);

		if (options.shortcut_key) {
			$('body').on('keydown', function(e) {
				if (e.ctrlKey && e.altKey && e.keyCode === options.shortcut_key) {
					setEnabled(!_enabled);
				}
			});
		}

		log.verbose('Initialized');
	}

	function setEnabled(val) {
		_enabled = val;
		onTextOutputEnabledChanged();
		onDotsEnabledChanged();
		log.info('Debugger has been ' + (val ? 'ENABLED' : 'DISABLED'));
	}

	function setShowDots(val) {
		_showDots = val;
		onDotsEnabledChanged();
		log.info('Dots output has been ' + (val ? 'ENABLED' : 'DISABLED'));
	}

	function update() {
		if (!_enabled) {
			return;
		}

		const hotspots = deps.krPanoClient.getHotspots();

		doUpdateTextOutput(hotspots);

		if (_showDots) {
			doUpdateDots(hotspots);
		}
	}

	function onTextOutputEnabledChanged() {
		if (!_textElements && _enabled) {
			_textElements = createTextOutputElement();
		}
		if (!_textElements) {
			return;
		}
		setElementInDOM(_textElements.$wrapper, _enabled);
	}

	function onDotsEnabledChanged() {
		if (!_showDots || !_enabled) {
			doUpdateDots([]);
		}
	}

	/**
	 * @param {Hotspot[]} hotspots
	 */
	function doUpdateTextOutput(hotspots) {
		hotspots = hotspots.slice();
		hotspots.sort(sortByDistance);

		const lines = hotspots.map(hotspot => {
			return padRight(hotspot.id ? ('<' + hotspot.id + '>') : '', 20)
				+ padRight(hotspot.name, 20)
				+ padRight(hotspot.normalizedPosterUrl || hotspot.normalizedUrl || '???', 60)
				+ padRight('dx: ' + hotspot.dx, 12)
				+ padRight('dy: ' + hotspot.dy, 12)
				+ padRight('dist: ' + hotspot.distance, 12)
				+ padRight('loc: ' + hotspot.location, 20);
		});

		const output = lines.join('\n');
		if (output === _lastOutput) {
			return;
		}

		_textElements.$output.text(output);
		_lastOutput = output;
	}

	/**
	 * @param {Hotspot[]} hotspots
	 */
	function doUpdateDots(hotspots) {
		const seen = {};

		// Create new
		hotspots.forEach(hotspot => {
			if (!(hotspot.x >= 0 && hotspot.y >= 0 && hotspot.id)) {
				return;
			}

			let $el = _dotElements[hotspot.name];
			if (!$el) {
				$el = createDotElement(hotspot.id || hotspot.name);
				_dotElements[hotspot.name] = $el;
			}
			$el.css('top', hotspot.y + 'px');
			$el.css('left', hotspot.x + 'px');
			flashDotSize($el);
			seen[hotspot.name] = true;
		});

		// Delete old
		for (let name in _dotElements) {
			if (_dotElements.hasOwnProperty(name) && !seen[name]) {
				setElementInDOM(_dotElements[name]);
				delete _dotElements[name];
			}
		}
	}

	function createTextOutputElement() {
		const $output = $('<pre style="background: rgba(0,0,0,0.7); color: #eee; font-family: monospace!important;">');
		const $wrapper = $('<div style="z-index: 1000000; position: fixed; top: 0; width: 100%; max-height: 25%; overflow: auto">');
		$wrapper.append($output);

		return {
			$wrapper: $wrapper,
			$output: $output
		};
	}

	function createDotElement(title, color) {
		color = color || DEFAULT_DOT_COLOR;
		const $el = $('<div style="background: ' + color + '; border-radius: 100%; '
			+ 'position: fixed; z-index: 100000" title="' + title + '">');
		setElementInDOM($el, true);
		return $el;
	}

	function flashDotSize($el, size) {
		size = size || DEFAULT_DOT_SIZE;
		$el.css('transition', 'inherit');
		doSetDotSize($el, size * 1.5);
		setTimeout(() => {
			$el.css('transition', 'width 500ms ease-in, height 500ms ease-in, margin 500ms ease-in');
			doSetDotSize($el, size);
		}, 100);
	}

	function doSetDotSize($el, size) {
		$el.css('width', size + 'px');
		$el.css('height', size + 'px');
		$el.css('margin-left', (size * -0.5) + 'px');
		$el.css('margin-top', (size * -0.5) + 'px');
	}

	function setElementInDOM(el, value) {
		const $body = $('body');
		if (value) {
			$body.append(el);
		} else {
			$(el).remove();
		}
	}
}

// *********************************************************************************************************************

/**
 * @param {Hotspot} a
 * @param {Hotspot} b
 */
function sortByDistance(a, b) {
	if (a.distance === null) {
		return 1;
	}
	if (b.distance === null) {
		return -1;
	}
	return a.distance - b.distance;
}

// *********************************************************************************************************************

export default KrPanoDebugger;
